import { useNavigate } from 'react-router-dom';
import { logMessage } from './externalMethods';

const config = _CONFIG_;

/**
 * Hook-based error handler — for functional components
 */
export function useErrorHandler() {
    const navigate = useNavigate();

    function errorHandler(error, debug) {
        logMessage('Error', error);
        const errorPath = `/${config.language || 'en'}/error-page?debug=${debug}`;
        navigate(errorPath, { state: { error } });
    }

    return { errorHandler };
}

/**
 * Class-compatible error handler — pass navigate explicitly (from props)
 */
export function errorHandlerForClass(error, debug, navigate) {
    logMessage('Error', error);
    const errorPath = `/${config.language || 'en'}/error-page?debug=${debug}`;
    navigate(errorPath, { state: { error } });
}

/**
 * Direct error fallback handler — for class components like DataProvider
 * Must be called inside a class component that receives `navigate` via props
 */
export function errorFallbackHandler(error, lang, path, query, navigate) {
    logMessage('Error', error);

    let errorCode = '{}';
    let errorIndex = '';

    if (error.Exception.indexOf('statusCode') > -1) {
        errorIndex = error.Exception.indexOf('statusCode') + ('statusCode":').length;
    } else if (error.Exception.indexOf('code') > -1) {
        errorIndex = error.Exception.indexOf('code') + ('code ').length;
    }

    if (errorIndex) {
        errorCode = error.Exception.substring(errorIndex, errorIndex + 3);
    }

    // Save only the page from the full pathname
    const errorPath = path.slice(path.lastIndexOf('/') + 1);
    // Create the errorMessage as a custom combination; for example: getPrices-404-plans
    const errorMessage = `${error.Message.split(' ')[2]}-${errorCode}-${errorPath}`;

    const fallbackPath = query
        ? `/${lang}/fallback${query}&errorMessage=${errorMessage}`
        : `/${lang}/fallback?errorMessage=${errorMessage}`;

    navigate(fallbackPath);
}
